import { useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import StaffDashboard from "@/pages/StaffDashboard";

export default function Home() {
  const { user } = useAuth();
  return user?.role === "manager" ? <Dashboard /> : <StaffDashboard />;
}
